export const GENERATE_OTP = 'GENERATE_OTP';
export const VALIDATE_OTP = 'VALIDATE_OTP';
export const VALIDATE_OTP_COUNT = 'VALIDATE_OTP_COUNT';
export const VALIDATE_OTP_COUNT_RESET = 'VALIDATE_OTP_COUNT_RESET';
